function Tracker() {
    this.isAvailable = function () {
        return typeof amplitude !== 'undefined';
    };

    this.track = function (action, properties) {
        if (!this.isAvailable()) {
            return;
        }

        return amplitude.getInstance().logEvent(action, properties);
    };

    this.identify = function (userId) {
        if (!this.isAvailable()) {
            return;
        }

        amplitude.getInstance().setUserId(userId);
    };

    this.addSuperProperties = function (properties) {
        if (!this.isAvailable()) {
            return;
        }

        amplitude.getInstance().setUserProperties(properties);
    };

    this.trackLinks = function (query, event_name, properties) {
        if (!this.isAvailable()) {
            return;
        }

        $(document).on('click', query, function (ev) {
            ev.preventDefault();

            const link = $(this);

            if (typeof properties === 'function') {
                properties = properties(link[0]);
            }

            if (!properties) {
                properties = null;
            }

            amplitude.getInstance().logEvent(event_name, properties, function () {
                if (ev.ctrlKey || ev.metaKey) {
                    window.open(link.attr('href'));
                    return;
                }

                window.location = link.attr('href');
            });
        });
    };

    this.delegate_links = function (parent, selector, event_name, properties) {
        properties = properties || {};
        parent = parent || document.body;
        parent = $(parent);

        parent.on('click', selector, function (event) {
            var new_tab = event.which === 2 || event.metaKey || event.target.target === '_blank';

            properties.url = event.target.href;

            function callback() {
                if (new_tab) {
                    return;
                }

                window.location = properties.url;
            }

            if (!new_tab) {
                event.preventDefault();
                setTimeout(callback, 300);
            }

            amplitude.getInstance().logEvent(event_name, properties, callback);
        });
    };
}

let tracker = new Tracker();
window.tracker = tracker;

export default tracker;

(function () {
    if (USER_ID) {
        tracker.identify(USER_ID);

        tracker.addSuperProperties({
            type: JSvars.client.clients_type_id,
            discount: JSvars.client.clients_discount,
            lang: JSvars.client.lang,
            abc: JSvars.client.clients_abc,
            abc_months: JSvars.client.clients_abc_monthes,
            email_subscribed: JSvars.client.clients_email_subscribed,
            email_subscribed_news: JSvars.client.clients_email_subscribed_news,
            country: JSvars.client.clients_country,
            ui: IS_MOBILE ? 'mobile' : 'desktop',
        });
    }

    tracker.trackLinks('.sf-menu a', 'Переход на страницу из верхнего меню');
    tracker.trackLinks('.link_cabinet', 'Переход в кабинет');
    tracker.trackLinks('.user-cabinet', 'Переход в кабинет');

    tracker.trackLinks('.mega-menu a:not(.js-dont-track)', 'Переход в категорию каталога', function (el) {
        return {
            'Название категории': el.innerText,
        };
    });

    tracker.trackLinks('.main_link', 'Переход на страницу товара', function (el) {
        return {
            'Название товара': el.innerText,
        };
    });

    tracker.trackLinks('.lang_switch a', 'Смена языка сайта', function (el) {
        return {
            Язык: el.innerText,
        };
    });

    tracker.trackLinks('.account_menu a', 'Личный кабинет => Просмотр страницы', function (el) {
        return {
            Страница: el.innerText,
        };
    });

    tracker.trackLinks('#cd-primary-nav a', 'Переход на страницу из верхнего меню');
})();
